import React from "react";
import { func } from "prop-types";
import I18n from "pages/_components/I18n";
import FilterForm from "pages/echeck/Echecks/components/FilterForm";
import { today, date30DaysBefore, date365DaysAfter, date365DaysBefore } from "pages/echeck/utils";

const EmitedSideBarForm = ({ closeSidebar }) => {
    const initialValues = {
        createdRange: [date365DaysBefore, today],
        payedRange: [date30DaysBefore, date365DaysAfter],
    };

    return (
        <div className="container full-width">
            <I18n id="echecks.filter" component="h2" />{" "}
            <div className="text-left">
                <FilterForm isEmittedForm customValues={initialValues} closeSidebar={closeSidebar} />
            </div>
        </div>
    );
};

EmitedSideBarForm.propTypes = {
    closeSidebar: func.isRequired,
};

export default EmitedSideBarForm;
